import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Mail, Phone, MapPin } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-32 pb-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">Mentions Légales</h1>

        <div className="space-y-8">
          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 flex items-center">
              <Building2 className="h-6 w-6 mr-2 text-dk-blue" />
              Informations légales
            </h2>
            <div className="prose max-w-none">
              <p className="mb-4">
                Le site diagnosti-k.fr est édité par la société DIAGNOSTI-K, SARL au capital de 1000€,
                immatriculée au Registre du Commerce et des Sociétés de Avignon sous le numéro SIRET 94819680300019.
              </p>
              <p className="mb-4">
                N° TVA intracommunautaire : FR43948196803
              </p>
              <div className="flex items-start space-x-2 mb-2">
                <MapPin className="h-5 w-5 text-dk-blue flex-shrink-0 mt-1" />
                <p>95 Avenue Fernand Gonnet, 84850 Camaret-sur-Aigues</p>
              </div>
              <div className="flex items-start space-x-2 mb-2">
                <Phone className="h-5 w-5 text-dk-blue flex-shrink-0 mt-1" />
                <p>07 89 30 75 00</p>
              </div>
              <div className="flex items-start space-x-2">
                <Mail className="h-5 w-5 text-dk-blue flex-shrink-0 mt-1" />
                <p>Spskdiag@gmail.com</p>
              </div>
            </div>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Hébergement</h2>
            <p className="mb-4">
              Ce site est hébergé par Netlify, Inc.
              <br />
              44 Montgomery Street, Suite 300
              <br />
              San Francisco, California 94104
              <br />
              United States
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Propriété intellectuelle</h2>
            <p className="mb-4">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur
              et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les
              documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
            <p className="mb-4">
              La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est
              formellement interdite sauf autorisation expresse du directeur de la publication.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Responsabilité</h2>
            <p className="mb-4">
              Les informations fournies sur ce site le sont à titre informatif. L'éditeur s'efforce de contrôler
              leur exactitude et de les maintenir à jour mais ne peut garantir qu'elles soient exemptes d'erreurs.
              Toute erreur signalée à l'éditeur sera corrigée dans les meilleurs délais.
            </p>
            <p>
              Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres
              ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de DIAGNOSTI-K.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Données personnelles</h2>
            <p className="mb-4">
              Les informations recueillies sur ce site sont traitées selon les dispositions du Règlement Général
              sur la Protection des Données (RGPD) et de la loi Informatique et Libertés. Pour plus d'informations,
              consultez notre Politique de confidentialité.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Certification et assurance</h2>
            <p className="mb-4">
              DIAGNOSTI-K est une entreprise certifiée pour la réalisation de diagnostics immobiliers.
              Nous disposons de toutes les certifications nécessaires et d'une assurance responsabilité
              civile professionnelle pour l'exercice de nos activités.
            </p>
          </section>
        </div>
      </div>
    </motion.div>
  );
};

export default MentionsLegales;